import { useEffect, useState } from "react";

let ctx = null;
let muted = typeof window !== "undefined" && localStorage.getItem("sa-muted") === "1";
const listeners = new Set();

function audio() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

if (typeof window !== "undefined") {
  const unlock = () => audio();
  window.addEventListener("pointerdown", unlock, { once: true });
  window.addEventListener("touchstart", unlock, { once: true });
  window.addEventListener("keydown", unlock, { once: true });
}

function noiseBuffer(c, seconds) {
  const buf = c.createBuffer(1, c.sampleRate * seconds, c.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
  return buf;
}

export function playTurn() {
  const c = !muted && audio();
  if (!c || c.state !== "running") return;
  const t = c.currentTime;
  const src = c.createBufferSource();
  src.buffer = noiseBuffer(c, 0.7);
  const bp = c.createBiquadFilter();
  bp.type = "bandpass";
  bp.Q.value = 0.8;
  bp.frequency.setValueAtTime(900, t);
  bp.frequency.exponentialRampToValueAtTime(3800, t + 0.35);
  bp.frequency.exponentialRampToValueAtTime(1400, t + 0.65);
  const g = c.createGain();
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(0.22, t + 0.12);
  g.gain.exponentialRampToValueAtTime(0.0001, t + 0.68);
  src.connect(bp).connect(g).connect(c.destination);
  src.start(t);
  src.stop(t + 0.7);
}

export function playThud(delay = 0) {
  const c = !muted && audio();
  if (!c || c.state !== "running") return;
  const t = c.currentTime + delay;
  const osc = c.createOscillator();
  osc.type = "sine";
  osc.frequency.setValueAtTime(150, t);
  osc.frequency.exponentialRampToValueAtTime(48, t + 0.16);
  const og = c.createGain();
  og.gain.setValueAtTime(0.5, t);
  og.gain.exponentialRampToValueAtTime(0.0001, t + 0.22);
  osc.connect(og).connect(c.destination);
  osc.start(t);
  osc.stop(t + 0.25);
  const n = c.createBufferSource();
  n.buffer = noiseBuffer(c, 0.06);
  const lp = c.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 1200;
  const ng = c.createGain();
  ng.gain.setValueAtTime(0.25, t);
  ng.gain.exponentialRampToValueAtTime(0.0001, t + 0.06);
  n.connect(lp).connect(ng).connect(c.destination);
  n.start(t);
}

export function useMuted() {
  const [m, setM] = useState(muted);
  useEffect(() => {
    listeners.add(setM);
    return () => listeners.delete(setM);
  }, []);
  const toggle = () => {
    muted = !muted;
    localStorage.setItem("sa-muted", muted ? "1" : "0");
    if (!muted) audio();
    listeners.forEach((fn) => fn(muted));
  };
  return [m, toggle];
}
